"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "commessaggio": {
    "ac52ff35": [{
      "hkey": "6cf8a665",
      "slug": "bocca-chiavica",
      "name": "Bocca Chiavica",
      "primary": true,
      "skipSearch": false
    }],
    "boccachiavica": [{
      "hkey": "6cf8a665",
      "slug": "bocca-chiavica",
      "name": "Bocca Chiavica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;